export default "__VITE_ASSET__C8euv8_w__"